<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Código de detalle</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Tipo
                            </label>
                            <vs-select filter class="pt-0" placeholder="Seleccionar tipo" v-model="tipo">
                                <template #message-danger v-if="errorFields.includes('tipo')">
                                    Requerido
                                </template>
                                <vs-option label="Abono" value="abono">
                                    Abono
                                </vs-option>
                                <vs-option label="Cargo" value="cargo">
                                    Cargo
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label class="labelInput">Nombre</label>
                            <vs-input  type="text" class="pt-0"
                                v-model="nombre"
                                placeholder="Nombre" >
                            </vs-input>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getInfoCodigoDetalle()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row v-if="JSON.parse(personaRol).roles[0].id == 1">
                    <vs-col sm="12" lg="3" class="ml-auto">
                        <vs-button
                            success
                            class="ml-auto"
                            @click="activeCrear = ! activeCrear "
                        >
                            <i class="fas fa-plus mr-2"></i> Crear registro
                        </vs-button>
                    </vs-col>
                </vs-row>
                
                <vs-alert v-if="mostrar">
                    <template #title>
                        No se encontro información
                    </template>
                </vs-alert>
                <codigo-detalle :users="users" :tipo="tipoOpcion" @refreshTable="getInfoCodigoDetalle" :personaRol="personaRol"></codigo-detalle>
            </vs-col>
        </vs-row>
        <crear v-model="activeCrear" @refreshTable="getRefresh"></crear>
    </div>
</template>

<script>
import academico from '../../../../api/requests/academico'
import CodigoDetalle from './tabla-codigo.detalle.vue'
import crear from './modales/crear.vue'
export default {
    props: [
        'personaRol'
    ],
    data(){
        return{
            tipo: '',
            nombre: '',
            errorFields: [],
            users: [],
            mostrar: false,
            activeCrear: false,
            tipoOpcion: ''
        }
    },
    components:{
        CodigoDetalle,
        crear
    },
    methods:{
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.tipo)) {
                this.errorFields.push('tipo')
            }
            if (!this.errorFields.length){
                return {
                    tipo_index: this.tipo,
                    texto: this.nombre
                }
            } else {
                return null
            }
        },
        async getInfoCodigoDetalle(){
            const info = this.sanityForm()
            if(info){
                try{
                    const loading = this.$vs.loading()
                    const { data: response } = await academico.getInfoCodigoDetalle(info)
                    loading.close()
                    if(response.data){
                        this.mostrar = false
                        this.users = response.data
                        this.tipoOpcion = this.tipo
                    }else{
                        this.users = []
                        this.mostrar = true
                    }
                }catch{

                }
            }
        },
        async getRefresh(data){
            this.tipo = data
            const params = {
                tipo_index: data,
                texto: this.nombre
            }
            try{
                const loading = this.$vs.loading()
                const { data: response } = await academico.getInfoCodigoDetalle(params)
                loading.close()
                if(response.data){
                    this.mostrar = false
                    this.users = response.data
                }else{
                    this.users = []
                    this.mostrar = true
                }
            }catch{

            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 15px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }
</style>